import { Chart } from 'react-chartjs-2';
import { ChartProps } from '../ChartWidget';
import {
  Chart as ChartJS,
  ChartData,
  ChartOptions,
  LineController,
  LineElement,
  PointElement,
  LinearScale,
  Title,
  Filler
} from 'chart.js';

const LineChart = ({ data, labels, lineChartConfig }: ChartProps) => {
  const dataPoints = data as number[][];

  ChartJS.register(LineController, LineElement, PointElement, LinearScale, Title, Filler);

  const lineData: ChartData = {
    labels: labels,
    datasets: dataPoints.map((value, index) => {
      return {
        label: index.toString(),
        data: value,
        borderColor: lineChartConfig?.borderColor,
        borderWidth: lineChartConfig?.borderWidth,
        tension: lineChartConfig?.tension,
        pointRadius: lineChartConfig?.pointRadius,
        backgroundColor: lineChartConfig?.backgroundColor,
        fill: lineChartConfig?.fill
      };
    })
  };

  const lineOptions: ChartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false
      },
      tooltip: {
        enabled: false
      }
    },
    scales: {
      x: {
        display: false
      },
      y: {
        display: false
      }
    },
    elements: {}
  };

  return (
    <Chart
      id={'lineChartCanvas'}
      style={{ width: '100%', height: '100%' }}
      type={'line'}
      data={lineData}
      options={lineOptions}
      redraw
    />
  );
};

export default LineChart;
